import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { BaseControlValueAccessor } from '../base_control_value_accessor/base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'logzy-duration-field',
  templateUrl: './duration-field.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DurationFieldComponent),
    }
  ]
})
export class DurationFieldComponent extends BaseControlValueAccessor implements OnInit {

  @Input()
  customCurrencyFieldName = null;

  durationUrl = `${ApiRoutes.CurrencyMaster}currency/?currency_code=::search::`;

  @Input() formFieldName = null;

  @Input()
  days: number = 0;
  @Output()
  daysChange = new EventEmitter<number>();

  _duration = {
    duration_code: 'DAY',
    duration: 'Days'
  };

  @Input()
  get duration() {
    return this._duration.duration_code;
  }

  set duration(val) {
    this._duration.duration_code = val;
  }

  @Input()
  minValue: number = Number.MIN_VALUE;

  @Input()
  maxValue: number = Number.MAX_VALUE;

  @Input()
  maxlength: number = 5; // Mandatory input

  @Input()
  minlength: number = 0;

  @Output()
  durationChange = new EventEmitter<string>();

  durationList = [];

  ngOnInit(): void {
    this.durationList = [
      {
        duration_code: 'DAY',
        duration: 'Days'
      },
      {
        duration_code: 'MONTH',
        duration: 'Months'
      },
      {
        duration_code: 'YEAR',
        duration: 'Years'
      },
    ]
  }

  setDays(day) {
    this.days = day;
    this._errors = [];
    this.validate(day)
    this.daysChange.emit(day);
  }

  setDuration(dur) {
    if (dur) {
      this.durationChange.emit(dur.duration_code);
    }
  }

  getDisplay() {
    if (this.days != null) {
      return `${this.days} ${this.duration}`
    } else {
      return '-'
    }
  }

  default(event) {
    if (event.keyCode == 101 || event.keyCode == 43 || event.keyCode == 45 || event.keyCode == 46) {
      event.preventDefault();
    }
    // e=keyCode: 101
    //  +=keyCode43
    //   -=keyCode:45
  }

  override validate(val) {
    this.errors = [];

    if (val < 0 && !(val == null || val == undefined)) {
      this.errors.push(`Days cannot be less than 0`);
    }

    // if (val < this.minValue && !(val == null || val == undefined)) {
    //   this.errors.push(`Minimum value permitted is ${this.minValue}`);
    // }

    // if (val > this.maxValue) {
    //   this.errors.push(`Maximum value permitted is ${this.maxValue}`);
    // }
  }

}
